<template>
  <div class="c-select-item" :class="classes">
    <div class="c-header">
      <span class="c-header-title">{{ title }}</span>
      <el-button type="text" class="c-header-clear" v-if="clear" @click="$emit('on-clear')">清空全部</el-button>
    </div>
    <div class="c-search" :class="{ 'm-disabled': disabled }" v-if="search && !clear">
      <el-select v-model="gameGroupId" clearable filterable placeholder="全部游戏组" no-data-text="暂无数据" style="margin-right: 8px">
        <el-option v-for="item in gameGroupData" :key="item.id" :value="item.id" :label="item.name"> </el-option>
      </el-select>
      <el-select v-model="midGameId" clearable filterable placeholder="全部中间件游戏" no-data-text="暂无数据" style="margin-right: 8px">
        <el-option v-for="item in midGameData" :key="item.id" :value="item.id" :label="item.name"> </el-option>
      </el-select>
      <el-input v-model="keyword" style="width: 220px" placeholder="请输入关键字搜索" clearable :disabled="disabled" />
      <el-button type="primary" @click="$emit('on-search', { keyword, gameGroupId, midGameId })"> 查询 </el-button>
    </div>
    <div class="c-selecter-content" :style="clearStyle">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'selectItem',
  props: {
    title: {
      type: String
    },
    clear: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    search: {
      type: Boolean
    },
    gameGroupData: {
      type: Array,
      default: () => []
    },
    midGameData: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean
    }
  },
  computed: {
    classes() {
      return this.clear ? 'item-border' : ''
    },
    clearStyle() {
      return this.clear && this.search ? { height: `${48 + 246}px` } : ''
    }
  },
  watch: {
    visible(nVal) {
      if (!nVal) {
        this.keyword = ''
        this.gameGroupId = ''
        this.midGameId = ''
        this.$emit('on-search', { keyword: '', gameGroupId: '', midGameId: '' })
      }
    }
  },
  data() {
    return {
      keyword: '',
      gameGroupId: '',
      midGameId: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-item {
  background-color: #fff;

  &.item-border {
    border: solid 1px #dee4f5;
  }

  .c-header {
    padding: 0 12px;
    height: 34px;
    font-size: 14px;
    color: #333;
    border-bottom: solid 1px #dee4f5;
    background-color: #fafbfe;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .c-selecter-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 254px;
    width: 100%;
    padding-bottom: 8px;
  }

  .c-search {
    width: 100%;
    padding: 8px 10px;
    background-color: #fff;
    display: flex;
  }
}
</style>
